export default __webpack_public_path__ + "bdbd9d53f0b6bdad300031246b37284c.jpg";